import React from 'react';
import CountUp from 'react-countup';


// image
import Ab1 from '../../images/about.png'
import DoctorImg from '../../images/team/doctor.jpg';

const about = (props) => {
    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-12">
                        <div className="about_left">
                            <div className="image">
                                <img src={Ab1} alt="" />
                                    <span className="round-on"></span>
                                    <span className="round-two"></span>
                                    <div className="award">
                                        <div className="icon">
                                            <i className="flaticon-cup"></i>
                                        </div>
                                        <div className="text">
                                        <h2><CountUp end={15} enableScrollSpy />+</h2>
                                            <p>Years Of Experience</p>
                                        </div>
                                    </div>
                                    <div className="doctors">
                                        <ul>
                                            <li><img src={DoctorImg} alt="" /></li>
                                            <li><img src={DoctorImg} alt="" /></li>
                                            <li><img src={DoctorImg} alt="" /></li>
                                            <li><img src={DoctorImg} alt="" /></li>
                                            <li><span>50+</span></li>
                                        </ul>
                                        <h4>Available Doctors</h4>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="content">
                            <h2>About Medically</h2>
                            <h3>Your Smile & Happiness Is Our Mission</h3>
                            <p>Our health and hospital policies encompass the strategies, guidelines, and practices that healthcare organizations use to achieve their goals and objectives. These policies may vary depending on the size of the organization, its market position, and the competitive landscape.</p>
                            <p>We focus on providing the best care and strive to ensure that every aspect of our services contributes to improving patient well-being. We prioritize safety, comfort, and advanced healthcare solutions to meet the needs of our patients.</p>
                            <div className="ceo">
                                <div>
                                    <h4>Mr. Mahinda Jayasooriya</h4>
                                    <span>Managing Director</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default about;